<button (click)="openQuickPanel.emit()" class="button" fxFlex="grow" mat-button>
  <mat-icon>mail</mat-icon>
</button>
